import {DatePipe} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {SharedModule} from '../../../../shared/shared.module';
import {AdxErpPayloadDialogComponent} from '../../../adx-erp-panel/components/adx-erp-payload-dialog/adx-erp-payload-dialog.component';
import {ITmtErpSyncTimeline, ITmtErpSyncTimelineEvent} from '../../interfaces/tmt-erp-panel.interface';
import {TmtErpTimelineService} from '../../service/tmt-erp-timeline.service';

@Component({
  selector: 'app-tmt-erp-timeline-dialog',
  imports: [DatePipe, MatButton, MatProgressSpinner, SharedModule],
  templateUrl: './tmt-erp-timeline-dialog.component.html',
  styles: [`
    .timeline-summary {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 12px;
      font-size: 13px;
    }
    .timeline-table-wrap {
      overflow: auto;
      max-height: 62vh;
    }
    table.timeline {
      width: 100%;
      border-collapse: collapse;
      font-size: 12px;
    }
    table.timeline th, table.timeline td {
      border-bottom: 1px solid #e0e0e0;
      padding: 6px 8px;
      text-align: left;
      vertical-align: top;
    }
    table.timeline th {
      position: sticky;
      top: 0;
      background: #fafafa;
      z-index: 1;
    }
    .error-link {
      color: #d32f2f;
      text-decoration: underline;
      cursor: pointer;
    }
    .status-ok { color: #2e7d32; }
    .status-fail { color: #d32f2f; }
    .status-pending { color: #ed6c02; }
  `],
})
export class TmtErpTimelineDialogComponent implements OnInit {
  protected readonly dialogRef = inject(MatDialogRef<TmtErpTimelineDialogComponent>);
  protected readonly data = inject<{salesOrderId: number; tripReference: string}>(MAT_DIALOG_DATA);
  private readonly timelineService = inject(TmtErpTimelineService);
  private readonly dialog = inject(MatDialog);

  protected loading = true;
  protected error: string | null = null;
  protected timeline: ITmtErpSyncTimeline | null = null;

  ngOnInit(): void {
    this.timelineService.getTimeline(this.data.salesOrderId).subscribe({
      next: (timeline) => {
        this.timeline = timeline;
        this.loading = false;
      },
      error: (err: Error) => {
        this.error = err.message;
        this.loading = false;
      },
    });
  }

  protected statusClass(event: ITmtErpSyncTimelineEvent): string {
    if (event.isFailed) return 'status-fail';
    if (event.isSynced) return 'status-ok';
    return 'status-pending';
  }

  protected statusLabel(event: ITmtErpSyncTimelineEvent): string {
    if (event.isFailed) return 'Failed';
    if (event.isSynced) return 'Synced';
    return 'Pending';
  }

  protected latestResult(event: ITmtErpSyncTimelineEvent): string {
    const last = event.responses?.length ? event.responses[event.responses.length - 1] : null;
    return last?.result ?? '';
  }

  protected latestOrder(event: ITmtErpSyncTimelineEvent): string {
    const last = event.responses?.length ? event.responses[event.responses.length - 1] : null;
    return last?.erpOrderNumber ?? '';
  }

  protected latestTrailer(event: ITmtErpSyncTimelineEvent): string {
    const last = event.responses?.length ? event.responses[event.responses.length - 1] : null;
    return last?.erpTrailerId ?? '';
  }

  protected latestFile(event: ITmtErpSyncTimelineEvent): string {
    const last = event.responses?.length ? event.responses[event.responses.length - 1] : null;
    return last?.fileName ?? '';
  }

  protected openError(title: string, content: string): void {
    this.dialog.open(AdxErpPayloadDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      data: {title, content},
    });
  }
}
